import { removeInvalidLayouts, removeLayoutsWithoutColumnNumbers, changeDuplicatedCustomLayouts, changeDuplicatedCurrentLayouts, changeCustomLayoutsCalledDefault, removeInvalidFields } from './layout-corrections.esm.js';
import { loadLayouts } from './load-layouts.esm.js';
import { normalizeEntities } from './normalize-entities.esm.js';
import { deleteLayout } from './delete-layout.esm.js';
import { saveLayout } from './save-layout.esm.js';

function bootstrapServices(props) {
  if (!props.entityTag || !props.groupTag || !props.delUserEntity || !props.getUserEntities || !props.setUserEntity) {
    return undefined;
  }
  var serviceNamespace = {
    entityTag: props.entityTag,
    groupTag: props.groupTag
  };
  var _removeInvalidLayouts = removeInvalidLayouts(serviceNamespace, props.delUserEntity);
  var _removeLayoutsWithoutColumnNumbers = removeLayoutsWithoutColumnNumbers(serviceNamespace, props.delUserEntity);
  var _changeDuplicatedCustomLayouts = changeDuplicatedCustomLayouts(serviceNamespace, props.delUserEntity, props.setUserEntity);
  var _changeDuplicatedCurrentLayouts = changeDuplicatedCurrentLayouts(serviceNamespace, props.delUserEntity, props.setUserEntity);
  var _removeInvalidFields = removeInvalidFields();
  var _changeCustomLayoutsCalledDefault = changeCustomLayoutsCalledDefault(serviceNamespace, props.delUserEntity);
  var _normalizeEntities = normalizeEntities(_removeInvalidLayouts, _removeLayoutsWithoutColumnNumbers, _changeDuplicatedCustomLayouts, _changeDuplicatedCurrentLayouts, _removeInvalidFields, _changeCustomLayoutsCalledDefault);
  var _loadLayouts = loadLayouts(serviceNamespace, props.getUserEntities, _normalizeEntities);
  var _deleteLayout = deleteLayout(serviceNamespace, props.delUserEntity);
  var _saveLayout = saveLayout(serviceNamespace, props.setUserEntity);
  return {
    loadLayouts: _loadLayouts,
    deleteLayout: _deleteLayout,
    saveLayout: _saveLayout
  };
}

export { bootstrapServices };
//# sourceMappingURL=bootstrap-services.esm.js.map
